var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',{staticClass:"text-no-wrap"},[_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.name))])]),_c('td',{staticClass:"pa-0"},[_c('v-simple-table',{staticClass:"ma-0"},[_c('tbody',_vm._l((_vm.values),function(value,idx){return _c('tr',{key:`tr-${idx}`},[_c('td',[_vm._v(_vm._s(value))])])}),0)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }